import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

import IconButton from 'components/IconButton';
import ToggleSwitch from 'components/ToggleSwitch';

import arrowDownIcon from 'assets/icons/arrow-down.svg';
import arrowRightIcon from 'assets/icons/arrow-right.svg';

import './styles.css';

interface ToggleSelectFilterProps {
  value: any;
  label: string;
  data: Array<{label: string; value: string}>;
  classNameForTesting?: string;
  onChange: (scheduleTypes: Array<string>) => void;
}

class ToggleSelectFilter extends React.Component<ToggleSelectFilterProps> {
  state = {
    sectionOpened: false
  };

  toggleSection = () => {
    this.setState({sectionOpened: !this.state.sectionOpened});
  };

  onChange = (selectedKey: string) => {
    this.props.onChange(_.xor(this.props.value, [selectedKey]));
  };

  render() {
    return (
      <div
        className={classNames(
          `FilterSection ToggleSelectFilter`,
          {
            'FilterSection--opened': this.state.sectionOpened
          },
          this.props.classNameForTesting
        )}>
        <div className="FilterSection__header colab-centered-v colab-bold">
          <IconButton
            src={arrowRightIcon}
            srcActive={arrowDownIcon}
            alt="Toggle section"
            onClick={this.toggleSection}
            active={this.state.sectionOpened}
          />
          <div>{this.props.label}</div>
        </div>
        <div className="FilterSection__content">
          {this.props.data.map(({label, value}) => (
            <div
              key={label}
              className="ToggleSelectFilter__section colab-centered-v colab-bold colab-row-space-between">
              <div>{label}</div>
              <ToggleSwitch
                value={_.includes(this.props.value, value)}
                onChange={() => this.onChange(value)}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
}
export default ToggleSelectFilter;
